export class Maintenance {
    maintenanceId: any;
    scheduledDateTime: any=null;
    effectiveDateTime: any;
    priorMessage: string;
    priorNoticeDay: any;
    isExistingUser: boolean;
    isActive: boolean;
    showPriorMessage: boolean=false;
    isMaintenanceInProgress:boolean=false;
    maintenanceBeforeHourList: MaintenanceBeforeHour[] = [];
    maintenanceBeforeMinuteList: MaintenanceBeforeMinute[] = [];
    maintenanceBeforeSecondList: MaintenanceBeforeSecond[] = [];
}

export class MaintenanceBeforeHour {
    maintenanceId:any;
    warningMessage :string;
    hour: number;
    isActive: boolean;
    isCompleted:boolean=false;
}

export class MaintenanceBeforeMinute {
    maintenanceId:any;
    warningMessage :string;
    minute: number;
    isActive: boolean;
    isCompleted:boolean=false;
}

export class MaintenanceBeforeSecond{
    maintenanceId:any;
    warningMessage :string;
    second: number;
    isActive: boolean;
    isCompleted:boolean=false;
}